module.exports = __webpack_public_path__ + "img/pago-facil.7087d60.svg";